export type ParticipationRateMethod =
    | 'On-truck technology such as cameras, GPS, and/or RFID systems'
    | 'Periodic route audits (e.g., manual counts)'
    | 'Extrapolated from set-out rates'
    | 'Integrated with on-the-street contamination audits'
    | 'Participation is estimated but not measured'
    | 'Other';


export const PARTICIPATION_RATE_METHODS: ParticipationRateMethod[] = [
    'On-truck technology such as cameras, GPS, and/or RFID systems',
    'Periodic route audits (e.g., manual counts)',
    'Extrapolated from set-out rates',
    'Integrated with on-the-street contamination audits',
    'Participation is estimated but not measured',
    'Other'
];
